import React from 'react';
import { Building2, FileText, HelpCircle, CreditCard, X } from 'lucide-react';
import { LinkedRecord } from '../types/email';
interface RecordCardProps {
  record: LinkedRecord;
  onUnlink: () => void;
}
const typeIcons = {
  company: Building2,
  case: FileText,
  enquiry: HelpCircle,
  transaction: CreditCard
};
const typeColors = {
  company: {
    text: '#1976d2',
    bg: '#e3f2fd'
  },
  case: {
    text: '#7b1fa2',
    bg: '#f3e5f5'
  },
  enquiry: {
    text: '#e65100',
    bg: '#fff3e0'
  },
  transaction: {
    text: '#2e7d32',
    bg: '#e8f5e9'
  }
};
export function RecordCard({
  record,
  onUnlink
}: RecordCardProps) {
  const Icon = typeIcons[record.type];
  const colors = typeColors[record.type];
  return <div className="flex items-start gap-3 p-3 bg-white border rounded group hover:shadow-sm transition-shadow" style={{
    borderColor: 'var(--border-light)'
  }} data-id="element-78">
      <div className="p-2 rounded" style={{
      backgroundColor: colors.bg,
      color: colors.text
    }} data-id="element-79">
        <Icon className="w-4 h-4" data-id="element-80" />
      </div>
      <div className="flex-1 min-w-0" data-id="element-81">
        <div className="flex items-center gap-2 mb-1" data-id="element-82">
          <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-83">
            {record.type}
          </span>
          <span className="text-xs font-mono text-gray-400" data-id="element-84">
            {record.referenceNumber}
          </span>
        </div>
        <p className="text-sm font-medium text-gray-900" data-id="element-85">{record.name}</p>
        {record.metadata && <div className="flex gap-3 mt-1" data-id="element-86">
            {Object.entries(record.metadata).map(([key, value]) => <span key={key} className="text-xs text-gray-600" data-id="element-87">
                <span className="font-medium capitalize" data-id="element-88">{key}:</span> {value}
              </span>)}
          </div>}
      </div>
      <button onClick={onUnlink} className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors opacity-0 group-hover:opacity-100" title="Unlink record" data-id="element-89">
        <X className="w-4 h-4" data-id="element-90" />
      </button>
    </div>;
}